import React from 'react';
import ctl from '@netlify/classnames-template-literals';
import isNumber from 'lodash/isNumber';
import './Shimmer.scss';
const ShimmerComponent = ({ width = '150px', height = '25px', circle, customClass, widthRandomness, heightRandomness, isWhiteBackground = true }) => {
    let finalWidth = width;
    let finalHeight = height;
    if (widthRandomness) {
        const w = isNumber(width) ? width : parseFloat(width);
        const unit = width.toString().replace(/\d+/g, '');
        finalWidth = '' + (w - Math.random() * w * widthRandomness) + unit;
    }
    if (heightRandomness) {
        const h = isNumber(height) ? height : parseFloat(height);
        const unit = height.toString().replace(/\d+/g, '');
        finalHeight = '' + (h - Math.random() * h * heightRandomness) + unit;
    }
    const shimmerCN = ctl(`
    animate
    inline-block
    ${!isWhiteBackground && 'base'}
    ${circle && 'rounded-full'}
    ${customClass && customClass}
  `);
    return (React.createElement("span", { className: shimmerCN, style: { height: finalHeight, width: finalWidth } }));
};
const Shimmer = ({ align = 'vertical', count = 0, width = '150px', height = '25px', circle = false, customClass, widthRandomness = 0, heightRandomness = 0, isWhiteBackground }) => {
    const wrapperCN = ctl(`
    flex
    ${align == 'vertical' ? 'flex-col' : ''}
    ${align == 'horizontal' ? 'flex-row' : ''}
  `);
    if (count && count > 0) {
        const element = [];
        const customClassCN = ctl(`
      ${customClass && customClass}
      ${align == 'vertical' && 'mb-[8px]'}
      ${align == 'horizontal' && 'mr-[8px]'}
    `);
        for (let i = 0; i < count; i++) {
            element.push(React.createElement(ShimmerComponent, { width: width, height: height, circle: circle, widthRandomness: widthRandomness, heightRandomness: heightRandomness, isWhiteBackground: isWhiteBackground, customClass: customClassCN, key: i }));
        }
        return React.createElement("div", { className: wrapperCN }, element);
    }
    return (React.createElement(ShimmerComponent, { width: width, height: height, circle: circle, widthRandomness: widthRandomness, heightRandomness: heightRandomness, isWhiteBackground: isWhiteBackground, customClass: customClass }));
};
export default Shimmer;
